import { render, staticRenderFns } from "./base-under-construction.vue?vue&type=template&id=3c4a4ca6&"
import script from "./base-under-construction.vue?vue&type=script&lang=js&"
export * from "./base-under-construction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports